import styled from 'styled-components'
import { COLOR, GTR } from '@farewill/ui/tokens'

import NotesInput from 'components/notes-input'

// the pencil icon fills with currentColor, so mute it here
const StyledWrapper = styled.div<{ $standalone: boolean }>`
  margin-top: ${({ $standalone }) => ($standalone ? 0 : GTR.M)};

  svg {
    color: ${COLOR.GREY.MEDIUM};
  }
`

type Props = {
  name: string
  handleSave?: ({ name, value }: { name: string; value: string }) => void
  // the only thing in its card, so there's nothing to set it apart from
  standalone?: boolean
}

const NotesField = ({ name, handleSave, standalone = false }: Props) => (
  <StyledWrapper $standalone={standalone}>
    <NotesInput
      name={name}
      handleSave={handleSave}
      showTopBorder={!standalone}
    />
  </StyledWrapper>
)

export default NotesField
